import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getSearchProductsShowAllData } from "src/api/sp";
import { resetStore } from "src/store/actions";
import {
  decimal,
  formatToCurrency,
  formatToPercentage,
  numberWithCommas
} from "src/utils/genericFunctions";
import stringToNumber from "src/utils/stringToNumber";
import {
  ProductsShowAllInitialState,
  ProductsShowAllTableRequestParams
} from "./interface";

export const fetchProductsSearchShowAll = createAsyncThunk(
  "productsSearchShowAll",
  (payload: ProductsShowAllTableRequestParams) =>
    getSearchProductsShowAllData(payload)
);

export const initialState: ProductsShowAllInitialState = {
  data: [],
  status: "idle",
  error: null
};

const searchShowAllProductsSlice = createSlice({
  name: "productsSearchShowAll",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(resetStore, (state, action) => {
        return initialState;
      })
      .addCase(fetchProductsSearchShowAll.pending, (state) => {
        state.status = "pending";
      })
      .addCase(
        fetchProductsSearchShowAll.fulfilled,
        (state, { payload }: { payload: any }) => {
          state.status = "idle";
          if (payload?.data?.data?.length) {
            state.data = payload?.data?.data?.map((item: any) => {
              const onOrder = formatToCurrency(stringToNumber(item?.onOrder));
              const wos = String(decimal(item?.wos || ""));
              const retail = formatToCurrency(stringToNumber(item?.retail));
              const salesUnit = decimal(item?.salesUnit);
              const value = formatToCurrency(stringToNumber(item?.value));
              const salesRetail = formatToCurrency(
                stringToNumber(item?.salesRetail)
              );
              const onHand = numberWithCommas(stringToNumber(item?.onHand));
              const avgRetail = formatToCurrency(
                stringToNumber(item?.avgRetail)
              );
              const margin = formatToPercentage(decimal(item?.margin));
              return {
                ...item,
                onHand,
                onOrder,
                wos: {
                  wos
                },
                retail,
                salesUnit,
                salesRetail,
                avgRetail,
                margin,
                value,
                itemName: item.itemId,
                wosValue: wos
              };
            });
          } else {
            state.data = [];
          }
        }
      )
      .addCase(fetchProductsSearchShowAll.rejected, (state) => {
        state.status = "error";
        state.data = [];
      });
  }
});

export const selectProductsShowAllData = (state: any) =>
  state.searchShowAllProducts.data;

export const selectProductsStatus = (state: any) =>
  state.searchShowAllProducts.status;

export default searchShowAllProductsSlice.reducer;
